import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import routes from '../../routes';

export default class LinkToSingle extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
    selectSingleResource: PropTypes.func.isRequired,
  };

  selectSingleResource = () => {
    const { value, resourceType, selectSingleResource } = this.props;

    selectSingleResource(value, resourceType);
  };

  render() {
    const { children } = this.props;

    return (
      <NavLink
        className="cell-link"
        onClick={this.selectSingleResource}
        to={routes.dashboard.PROVISION_QUALITY_SINGLE}
      >
        {children}
      </NavLink>
    );
  }
}
